import { NumberFormatType } from '../enum/formatPricePercentEnum';
import formatterNumber from './formatterNumber';

const truncateValue = (value: number) => {
  return parseFloat(value.toFixed(10).slice(0, -8));
};

export default function formatterPriceTruncate(
  value: number,
  options?: Intl.NumberFormatOptions,
) {
  const truncatedValue = truncateValue(value);

  return formatterNumber(truncatedValue, {
    style: NumberFormatType.currency,
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  });
}
